type HomeNavIconProps = React.SVGProps<SVGSVGElement>;

const HomeNavIcon: React.FC<HomeNavIconProps> = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.5 12L3.83333 9.66667M3.83333 9.66667L12 1.5L20.1667 9.66667M3.83333 9.66667V21.3333C3.83333 21.6428 3.95625 21.9395 4.17504 22.1583C4.39383 22.3771 4.69058 22.5 5 22.5H8.5M20.1667 9.66667L22.5 12M20.1667 9.66667V21.3333C20.1667 21.6428 20.0438 21.9395 19.825 22.1583C19.6062 22.3771 19.3094 22.5 19 22.5H15.5M8.5 22.5C8.80942 22.5 9.10616 22.3771 9.32496 22.1583C9.54375 21.9395 9.66667 21.6428 9.66667 21.3333V16.6667C9.66667 16.3572 9.78958 16.0605 10.0084 15.8417C10.2272 15.6229 10.5239 15.5 10.8333 15.5H13.1667C13.4761 15.5 13.7728 15.6229 13.9916 15.8417C14.2104 16.0605 14.3333 16.3572 14.3333 16.6667V21.3333C14.3333 21.6428 14.4562 21.9395 14.675 22.1583C14.8938 22.3771 15.1906 22.5 15.5 22.5M8.5 22.5H15.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export default HomeNavIcon;
